import { DateTime } from 'luxon';

import { useLocalStorage } from 'src/common/util/useLocalStorage/useLocalStorage';

const STORAGE_KEY = 'developerPlatformAnnouncementSeen';

// Bump to announce the portal again. Stored rather than compared to a boolean
// because getStorageValue falls back to its default on any falsy read.
const ANNOUNCEMENT_ID = 'launch';

// Clicking the entry is the only thing that clears the badge, so without an end
// date someone who never opens the menu keeps it forever.
const ANNOUNCEMENT_ENDS = '2026-11-15T00:00:00Z';

export function useDeveloperPlatformAnnouncement() {
  const [seen, setSeen] = useLocalStorage(STORAGE_KEY, '');
  const isWithinWindow = DateTime.now() < DateTime.fromISO(ANNOUNCEMENT_ENDS);

  return {
    isNew: isWithinWindow && seen !== ANNOUNCEMENT_ID,
    markSeen: () => setSeen(ANNOUNCEMENT_ID),
  };
}
